import MedicationModal from './MedicationModal';

export default MedicationModal;
